import {
  NotificationType,
  OAINotification,
  OrderStatus,
} from '@oai-frontend-monorepo/types';

const getRouteForNotification = (notification: OAINotification) => {
  const type = notification.type;

  if (!type) {
    throw new Error('Notification type not available');
  }

  switch (type.toUpperCase()) {
    case NotificationType.Order.toUpperCase(): {
      return getRouteForOrderNotification(notification);
    }
    default: {
      return '#';
    }
  }
};

const getRouteForOrderNotification = (notification: OAINotification) => {
  // determine subtype
  switch (notification.subtype?.toUpperCase()) {
    case OrderStatus.Filled.toUpperCase(): {
      if (
        notification.secondaryType?.toUpperCase() ===
        NotificationType.Position.toUpperCase()
      ) {
        return `/positions/${notification.secondaryTypeId}`;
      }

      return `/orders`;
    }
    default: {
      return '/positions';
    }
  }
};

export default getRouteForNotification;

// filled notification on open
// {
//     "id": "56624d87-4525-40eb-a5bd-1c8b4faca4af",
//     "accountId": "c838ef10-2fe3-4142-9e19-652ed704b62c",
//     "type": "ORDER",
//     "secondaryType": "POSITION",
//     "subtype": "FILLED",
//     "typeId": "14816855",
//     "secondaryTypeId": "c6af5cb0-157a-49f2-9bb1-4a5baaeac7c8",
//     "message": "You sold to open, 1 SPY 563/564 Put Spread (11/07) at an average price of -$0.22.",
//     "createdAt": "2024-11-05T15:43:57.070331Z",
//     "readAt": null,
//     "symbol": "SPY",
//     "subtypeId": "1",
//     "platform": "ANY",
//     "metaData": null
// }
